export function audytor() {
// Odpowiedz spoza naszego kodu (blad posrednika, przekroczony czas, awaria PHP)
// nie jest JSON-em. Do 8.09.2026 leciala wprost do uzytkownika jako
// "Unexpected token '<'", czyli komunikat parsera zamiast zdania po polsku.
async function odczytajOdpowiedz(response) {
    const tekst = await response.text();
    try {
        return JSON.parse(tekst);
    } catch (e) {
        if (response.status === 524 || response.status === 504 || response.status === 408) {
            throw new Error('Analiza trwa dłużej niż zwykle i połączenie zostało przerwane. Spróbuj jeszcze raz za chwilę.');
        }
        if (response.status >= 500) {
            throw new Error('Nasz serwer nie dokończył analizy. Spróbuj ponownie za kilka minut.');
        }
        throw new Error('Nie udało się odczytać odpowiedzi serwera. Spróbuj ponownie za chwilę.');
    }
}

    const form = document.getElementById('analyzeForm');
    let progress = 0;

    // Pomiar krokow lejka (audyt UX 20.08.2026): do tej pory audytor WPPlan
    // wysylal tylko zdarzenia Meta, wiec w GA4 nie dalo sie policzyc, ilu
    // odbiorcow dociera do wyniku i ilu z nich zostawia adres. Nazwy takie same
    // jak w audytorze LocalOne, zeby oba lejki dalo sie porownac.
    function pushDL(name, params) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(Object.assign({ event: name }, params || {}));
    }
    const preloader = document.querySelector('.preloader');
    const preloaderData = document.querySelector('.preloader__data');
    const resultsContainer = document.getElementById('test_results');
    const urlInput = document.getElementById('url');


    urlInput.addEventListener('blur', () => {
        urlInput.value = normalizeUrl(urlInput.value);
        isValidUrl(urlInput.value);
    });

    form.addEventListener('submit', async (event) => {
        event.preventDefault();
        urlInput.value = normalizeUrl(urlInput.value);
        const url = urlInput.value;

        // Walidacja URL
        if (!isValidUrl(url)) {
            return;
        } else {
            clearError();
        }

        // Meta Pixel: start audytu to ViewContent, NIE Lead. Lead pada dopiero przy
        // bramce z adresem (poprawione 23.08.2026 - wczesniej kampania optymalizowana
        // pod "Lead" uczylaby sie sciagac klikaczy zamiast osob zostawiajacych adres).
        if (typeof fbq === 'function') {
            fbq('track', 'ViewContent', {content_name: url, content_category: 'wp_audit'});
        }
        pushDL('audit_requested', { audit_query: url });

        document.querySelector('.app').classList.add('show');
        document.querySelector('body').classList.add('showMenu');
        document.getElementById('siteUrl2').textContent = url;

        const actions = [
            { name: 'check_wp_login', description: 'Sprawdzanie strony logowania WordPress...' },
            { name: 'check_google_safe_browsing', description: 'Sprawdzanie statusu Google Safe Browsing...' },
            { name: 'check_stopforumspam', description: 'Sprawdzanie bazy danych StopForumSpam...' },
            { name: 'detect_plugins_with_versions', description: 'Wykrywanie wtyczek z wersjami...' },

            { name: 'check_security_headers', description: 'Sprawdzanie nagłówków bezpieczeństwa...' },
            { name: 'check_webp_support', description: 'Sprawdzanie obsługi obrazów WebP...' },
            // { name: 'get_pagespeed_details', description: 'Sprawdzanie wyniku PageSpeed...' },

            // { name: 'get_blogvault_sites', description: 'Uzyskiwanie stron z WpPlan...' },
            { name: 'get_summary', description: 'Finalizacja...' }
            //   { name: 'analyze_headers_with_gpt', description: 'Analizowanie nagłówków za pomocą GPT...' },
        ]; // Przykładowe akcje
        const progressIncrement = 100 / actions.length;
        preloader.classList.add('active');
        resultsContainer.classList.add('active');

        for (const action of actions) {
            const messageElement = document.createElement('div');
            messageElement.innerHTML = action.description;
            messageElement.classList.add('result-message'); // Dodanie klasy
            const previousMessages = resultsContainer.querySelectorAll('.result-message');
            previousMessages.forEach(message => message.classList.add('hide'));
            resultsContainer.appendChild(messageElement);
            window.setTimeout(() => {
                messageElement.classList.add('show');
            }, 100);

            const response = await fetch('wp-content/themes/audytor/api.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ url, action: action.name })
            });


            const data = await odczytajOdpowiedz(response);

            if (data.status === 'ok') {

                progress += progressIncrement;
                updatePreloaderData(progress, 1000); // Aktualizacja preloadera
                if (progress >= 99) {
                    showResults(data);
                    return;
                }
            } else if (data.status == 'error_alert') {
                document.querySelector('.app').classList.remove('show');
                const errorMessage = document.createElement('div');
                errorMessage.classList.add('error-alert');
                errorMessage.innerHTML = data.message;
                document.querySelector('.subpageHeader__text').appendChild(errorMessage);
                break;
            } else {
                console.error('Error:', data.message);
                break;
            }
        }
    });


    function showResults(data) {

        document.querySelector('.app__header').classList.add('step2');
        document.querySelector('.app__testinfoContent h2').innerHTML = 'Analiza zakończona';

        // Po zakonczeniu analizy pasek postepu musi zniknac. Bez tego zostawal
        // z klasa "active" i zjadal 160 px pustki w karcie naglowka - na telefonie
        // wypychalo to wyniki pod krawedz ekranu (audyt UX 20.08.2026).
        preloader.classList.remove('active');
        preloaderData.textContent = '0%';
        const etykietaKroku = document.getElementById('stepLabel');
        if (etykietaKroku) etykietaKroku.textContent = '';
        const kontenerKrokow = document.getElementById('test_results');
        if (kontenerKrokow) {
            kontenerKrokow.querySelectorAll('.result-message').forEach(el => el.remove());
        }

        pushDL('audit_completed', {
            audit_query: document.getElementById('siteUrl2').textContent
        });

        const results = document.createElement('div');
        results.classList.add('app__finally');
        results.innerHTML = data.data;

        document.querySelector('.app__content').appendChild(results);
        addEmailForm();

        const scroll_to_form = document.querySelector('.app__gotoform');
        scroll_to_form.addEventListener('click', () => {
            jQuery('.app').animate({ 'scrollTop': ($('#emailForm').offset().top) + 'px' }, 500);

        });

        podepnijSpisTresci(results);
    }

    /**
     * Spis tresci wygladal na nawigacje (numery, klodki), ale nie byl klikalny,
     * a pozycje zamkniete sa najmocniejsza zacheta do zostawienia adresu
     * (audyt UX 20.08.2026).
     */
    function podepnijSpisTresci(zakres) {
        const menu = zakres.querySelector('.finally-menu');
        if (!menu) return;
        menu.classList.add('finally-menu--klikalne');
        menu.addEventListener('click', (zdarzenie) => {
            const pozycja = zdarzenie.target.closest('li');
            if (!pozycja) return;
            if (pozycja.classList.contains('disabled')) {
                przewinDoBramki();
                return;
            }
            const klucz = pozycja.dataset.sekcja;
            const cel = klucz && document.getElementById('sekcja-' + klucz);
            if (cel) cel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
    }

    function przewinDoBramki() {
        const formularz = document.getElementById('emailForm');
        if (!formularz) return;
        formularz.scrollIntoView({ behavior: 'smooth', block: 'center' });
        const pole = document.querySelector('#emailForm input[type="email"], #userEmail');
        if (!pole) return;
        // Podswietlenie zamiast focus: na telefonie focus podnosi klawiature
        // i zaslania to, po co odbiorca tu przyszedl.
        pole.classList.add('pole--wskazane');
        window.setTimeout(() => pole.classList.remove('pole--wskazane'), 2200);
    }

    function addEmailForm() {
        const emailForm = document.createElement('div');
        emailForm.classList.add('finally-results__form');

        emailForm.innerHTML = `
            <h3>Odbierz pełny raport PDF</h3>
            <p>Wyniki wszystkich testów, ocena szybkości strony i wyjaśnienie prostym językiem, co poprawić najpierw.</p>
            <form id="emailForm">
                <div class="emailForm__form">
                    <div class="form-group">
                        <input type="email" id="userEmail" placeholder="Twój adres email" >
                        <div class="error-msg"></div>
                    </div>
                    <div class="form-group checkbox-group">
                        <input type="checkbox" id="rodoConsent" >
                        <label for="rodoConsent"><span>

    Akceptuję <a href="https://audytor.wpplan.pl/regulamin-uslugi/" target="_blank">Regulamin usługi audytor.wpplan.pl</a> i wyrażam zgodę na otrzymywanie od "Avangardo sp. z o.o." treści marketingowych i informacji handlowych, dotyczących produktów i usług "Avangardo sp. z o.o." poprzez kontakt e-mailowy.

    <span class="rodo-hidden-element">Możesz nie podawać danych do kontaktu handlowego i marketingowego i uzyskać raport w kwocie 99 zł. W tym celu napisz do nas na kontakt@wpplan.pl. Administratorem Twoich danych osobowych jest „Avangardo spółka z o.o.", z siedzibą w Szczecinie 70-655, przy ul. Wendy 10 lok. 3C, wpisaną do Krajowego Rejestru Sądowego pod numerem KRS: 0000942472, REGON: 520784536, NIP: 8513268189. Możesz wycofać zgodę w dowolnym momencie, kierując informację na iod@wpplan.pl. Wycofanie zgody nie wpływa na zgodność z prawem działań podjętych na podstawie zgody przed jej wycofaniem. Więcej w <a href="https://audytor.wpplan.pl/polityka-prywatnosci/" target="_blank">polityce prywatnosci</a>.</span>
                        <a class="rodo-hidden-element-trigger">Rozwiń więcej</a>

                        </span>

                        </label>
                        <div class="error-msg"></div>
                    </div>
                <button type="submit" class="btn mainBtn">Odbieram bezpłatny raport</button>
                </div>
                <div class="emailForm__generator"></div>
            </form>

        `;

        document.querySelector('.finally-results').appendChild(emailForm);

        const emailFormElement = document.getElementById('emailForm');
        const emailInput = document.getElementById('userEmail');
        const rodoConsent = document.getElementById('rodoConsent');
        const rodoHiddenElement = document.querySelector('.rodo-hidden-element');
        const rodoHiddenElementTrigger = document.querySelector('.rodo-hidden-element-trigger');
        rodoHiddenElementTrigger.addEventListener('click', (e) => {
            e.stopImmediatePropagation();
            e.preventDefault();
            rodoHiddenElement.classList.toggle('show');
            if (rodoHiddenElement.classList.contains('show')) {
                rodoHiddenElementTrigger.textContent = 'Zwiń';
            } else {
                rodoHiddenElementTrigger.textContent = 'Rozwiń więcej';
            }
            return false;
        });


        emailFormElement.addEventListener('submit', async (event) => {
            event.preventDefault();
            event.stopPropagation();

            // Validate email ...
            if (!validateEmail(emailInput.value)) {
                showInputError(emailInput, 'Wprowadź poprawny adres email');
                return;
            } else {
                clearInputError(emailInput);
            }

            // Validate RODO consent
            if (!rodoConsent.checked) {
                showInputError(rodoConsent, 'Aby kontynuować zaznacz to pole');
                return;
            } else {
                clearInputError(rodoConsent);
            }

            // Send data to API
            const email = emailInput.value;
            const url = document.getElementById('url').value;
            const emailForm__generator = document.querySelector('.emailForm__generator');
            const emailForm__form = document.querySelector('.emailForm__form');
            emailForm__form.classList.add('hide');
            emailForm__generator.classList.add('show');

            // Build progress UI using DOM methods (safe, no innerHTML with user data)
            const progressContainer = document.createElement('div');
            progressContainer.className = 'report-progress';

            const barContainer = document.createElement('div');
            barContainer.className = 'report-progress__bar-container';
            const bar = document.createElement('div');
            bar.className = 'report-progress__bar';
            bar.id = 'reportProgressBar';
            bar.style.width = '0%';
            barContainer.appendChild(bar);

            const stepText = document.createElement('p');
            stepText.className = 'report-progress__step';
            stepText.id = 'reportProgressStep';
            stepText.textContent = 'Przygotowywanie...';

            const infoText = document.createElement('p');
            infoText.className = 'report-progress__info';
            infoText.textContent = 'Nie zamykaj tej strony.';

            progressContainer.appendChild(barContainer);
            progressContainer.appendChild(stepText);
            progressContainer.appendChild(infoText);

            emailForm__generator.textContent = '';
            emailForm__generator.appendChild(progressContainer);

            // Start progress polling
            let progressInterval = null;
            const progressBar = document.getElementById('reportProgressBar');
            const progressStep = document.getElementById('reportProgressStep');

            progressInterval = setInterval(async () => {
                try {
                    const progResp = await fetch('wp-content/themes/audytor/api.php', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ action: 'check_progress' })
                    });
                    const prog = await progResp.json();
                    if (prog && prog.step) {
                        const pct = prog.percent || Math.round((prog.step / prog.total) * 100);
                        progressBar.style.width = pct + '%';
                        progressStep.textContent = 'Krok ' + prog.step + '/' + prog.total + ': ' + prog.message;
                    }
                } catch(e) { /* ignore polling errors */ }
            }, 1500);

            try {
                const response = await fetch('wp-content/themes/audytor/api.php', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        action: 'save_email',
                        email: email,
                        url: url
                    })
                });


                const data = await odczytajOdpowiedz(response);

                clearInterval(progressInterval);

                if (data.status === 'ok') {
                    progressBar.style.width = '100%';

                    // Meta Pixel: TU jest prawdziwy lead - odbiorca zostawil adres.
                    if (typeof fbq === 'function') {
                        fbq('track', 'Lead', {
                            content_name: url,
                            content_category: 'wp_audit',
                            status: true
                        });
                    }
                    pushDL('report_submitted', {
                        audit_query: document.getElementById('siteUrl2').textContent
                    });

                    // Do 20.08.2026 konczylo sie na "raport zostal wyslany" i cisza -
                    // w najcieplejszym momencie kontaktu odbiorca nie wiedzial, co
                    // dalej. Teraz pada zapowiedz kontaktu (decyzja Marcina 20.08).
                    const successMsg = document.createElement('p');
                    successMsg.className = 'success-message';
                    successMsg.textContent = 'Raport został wysłany na Twój adres e-mail.';

                    const nextStep = document.createElement('p');
                    nextStep.className = 'success-next';
                    nextStep.textContent = 'Odezwiemy się z krótkim podsumowaniem: co z tej listy zrobić najpierw. Bez zobowiązań.';

                    emailForm__generator.textContent = '';
                    emailForm__generator.appendChild(successMsg);
                    emailForm__generator.appendChild(nextStep);
                } else {
                    throw new Error(data.message || 'Wystąpił błąd podczas wysyłania formularza');
                }
            } catch (error) {
                clearInterval(progressInterval);
                console.error('Error:', error);
                emailForm__form.classList.remove('hide');
                emailForm__generator.classList.remove('show');
                showInputError(emailInput, error.message);
            }
        });

        function validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return re.test(String(email).toLowerCase());
        }

        function showInputError(inputElement, message) {
            const formGroup = inputElement.closest('.form-group');
            const errorElement = formGroup.querySelector('.error-msg');
            errorElement.textContent = message;
            formGroup.classList.add('has-error');
        }

        function clearInputError(inputElement) {
            const formGroup = inputElement.closest('.form-group');
            const errorElement = formGroup.querySelector('.error-msg');
            errorElement.textContent = '';
            formGroup.classList.remove('has-error');
        }
    }

    function normalizeUrl(string) {
        string = string.trim();
        if (!string) return string;
        // Auto-prepend https:// if no protocol
        if (!/^https?:\/\//i.test(string)) {
            string = 'https://' + string.replace(/^\/+/, '');
        }
        return string;
    }

    function isValidUrl(string) {
        try {
            string = normalizeUrl(string);
            new URL(string);
            clearError();
            return true;
        } catch (_) {
            displayError('Niepoprawny adres URL');
            return false;
        }
    }

    function displayError(message) {
        clearError();
        const errorElement = document.createElement('p');
        errorElement.textContent = message;
        errorElement.classList.add('error-message');
        form.appendChild(errorElement);
    }

    function clearError() {
        const errorElement = form.querySelector('.error-message');
        if (errorElement) {
            form.removeChild(errorElement);
        }
    }

    function updatePreloaderData(newValue, duration = 500) {
        const currentValue = parseInt(preloaderData.textContent, 10) || 0;
        const steps = duration / 10; // 10 ms na krok
        const increment = (newValue - currentValue) / steps;

        let currentStep = 0;
        const interval = setInterval(() => {
            currentStep++;
            const value = Math.round(currentValue + increment * currentStep);
            preloaderData.textContent = `${value}%`;

            if (currentStep >= steps) {
                clearInterval(interval);
            }
        }, 10); // 10 ms na krok
    }
}
